<template>
  <v-card>
    <v-form
      lazy-validation
      ref="form"
      v-model="validForm"
      @submit.prevent="onConfirm"
    >
      <v-card-title primary-title>
        Redigera kategori
      </v-card-title>

      <v-card-text>
        <v-text-field
          :rules="[validationRules.required]"
          v-model="model.name"
          label="Kategori"
        ></v-text-field>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="onClose">
          Avbryt
        </v-btn>
        <v-btn type="submit" color="primary" text>
          Uppdatera
        </v-btn>
      </v-card-actions>
    </v-form>
  </v-card>
</template>

<script>
import UPDATE_CATEGORY_GROUP from '@/gql/categoryGroups/mutations/UpdateCategoryGroup.gql'
import { validationRules } from '@/common/validationRules'
import { get } from 'vuex-pathify'

export default {
  name: 'MasterdataCategoriesEdit',

  props: {
    uuid: String,
  },

  data() {
    return {
      validationRules,
      validForm: true,
      model: {
        name: '',
      },
    }
  },

  created() {
    for (let prop in this.model) {
      this.model[prop] = this.categoryGroups[this.uuid][prop]
    }
  },

  computed: {
    categoryGroups: get('categoryGroups/data'),
  },

  methods: {
    async onConfirm() {
      const valid = await this.$refs.form.validate()
      if (!valid) return
      this.updateCategoryGroup()
      this.onClose()
    },

    onClose() {
      this.$emit('close')
    },

    updateCategoryGroup() {
      return this.$apollo.mutate({
        mutation: UPDATE_CATEGORY_GROUP,
        variables: {
          uuid: this.uuid,
          payload: this.model,
        },

        update: (store, { data }) => {
          this.$store.set('categoryGroups/data', {
            ...this.$store.get('categoryGroups/data'),
            [data.updateCategoryGroup.uuid]: data.updateCategoryGroup,
          })
        },
      })
    },
  },
}
</script>
